/*
 * Sticky header scroll-bounce fix
 * ---------------------------------------------------------------------------
 * Symptom: on desktop, scrolling up near the top of a page yanks you back down
 * repeatedly, so you cannot scroll up past the header.
 *
 * Cause: novtheme.StickyHeader (assets/global.js) shows the compact bar by
 * calling novtheme.toggleSticky, which uses swapChildren to physically detach
 * the logo / menu / account / wishlist / cart nodes and re-append them in the
 * other header. #header-sticky is position:fixed so it costs no layout, but
 * .site-header is position:relative and therefore IN FLOW -- emptying it
 * collapses it from ~201px to ~90px. The document shrinks by that same amount
 * and the browser silently drops scrollY to compensate. Near the top of the
 * page that drop re-crosses the activation threshold, so the handler toggles
 * again, and the page fights every attempt to scroll up.
 *
 * Fix: reserve the header's expanded height with a min-height before the swap
 * runs. The nodes still move and the compact bar still slides in, but
 * .site-header keeps its footprint, so document height never changes, scrollY
 * is never adjusted, and the oscillation cannot start.
 *
 * This wraps toggleSticky rather than editing global.js, so a Vinova theme
 * update won't silently drop the fix -- and StickyHeader looks the function up
 * on the novtheme object at call time, so wrapping it after bind still works.
 */
(function () {
  'use strict';

  // Matches the breakpoint novtheme.StickyHeader guards itself with.
  var DESKTOP_MIN_WIDTH = 767;

  function header() {
    return document.querySelector('.site-header');
  }

  function stickyIsActive() {
    var bar = document.querySelector('#header-sticky');
    return !!(bar && bar.classList.contains('sticky-header-active'));
  }

  // Grow-only: once the expanded height is known we keep it, so calling this
  // while the header is already collapsed can never shrink the reservation.
  function lockHeaderHeight() {
    var el = header();
    if (!el) return;
    if (window.innerWidth <= DESKTOP_MIN_WIDTH) return;

    var current = el.offsetHeight;
    var locked = parseFloat(el.style.minHeight) || 0;
    if (current > locked) el.style.minHeight = current + 'px';
  }

  function install() {
    if (!window.novtheme || typeof window.novtheme.toggleSticky !== 'function') return false;
    if (window.novtheme.__stickyBounceFixed) return true;

    var original = window.novtheme.toggleSticky;
    window.novtheme.toggleSticky = function () {
      lockHeaderHeight(); // reserve the space BEFORE any nodes move
      return original.apply(this, arguments);
    };
    window.novtheme.__stickyBounceFixed = true;
    return true;
  }

  // global.js and this file are both deferred so novtheme should already exist,
  // but poll briefly in case the load order ever changes.
  if (!install()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (install() || ++tries > 40) clearInterval(timer);
    }, 50);
  }

  // Re-measure after a resize, but never while the compact bar is showing --
  // clearing the reservation mid-swap would collapse the header under the reader.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (stickyIsActive()) return;
      var el = header();
      if (el) el.style.minHeight = '';
      lockHeaderHeight();
    }, 200);
  });

  // Lock once fonts and logo images have settled and the height is truthful.
  if (document.readyState === 'complete') {
    lockHeaderHeight();
  } else {
    window.addEventListener('load', lockHeaderHeight);
  }
})();
